import React from 'react';
import { Link } from 'react-router-dom';

import Redo from '../App/Redo'
import Banner from '../App/Banner';

import France from '../../assets/categories/France.PNG'
import Check from '../../assets/check.svg'
import Arrow from '../../assets/arrow.svg'
import GreyArrow from '../../assets/grey arrow.svg'

function FranceToFrance() {
  return(
    <div>
      <Banner />
      <div id="FranceToFrance" className='paper'>

        <Link to='/France'>
          <button className="return">
          <img src={GreyArrow} alt="fleche grise"/>
            Retour
          </button>
        </Link>

        <div className="breadcrumbs">
          <p><img src={Check} />Votre stock se situe en France</p>
          <p><img src={Check} />Vous vendez vers la France</p>
        </div>

        <h4>La procédure :</h4>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Appliquez le taux de TVA français</ul>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Déclarez votre TVA en France</ul>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Si vous êtes non assujetti à la TVA, vous restez exonéré de TVA</ul>
        <hr />

        <div className='categorie' >
          <h4>Si vous êtes client Dougs :</h4>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Sélectionnez la catégorie "Ventes de marchandises" ou "Ventes de produits finis" avec le bon taux de tva</ul>
          <img src={France} alt="Categorie France" />
        </div>

        <div className="button">
          <Redo />
        </div>

      </div>
    </div>
  )
}

export default FranceToFrance